import { Map, Record } from "immutable";

import QuizModuleStat from "./QuizModuleStat";

export type QuizStatType = {
  marksTotal?: number;
  totalStudyTime?: number;
  sessionsCompleted?: number;
  firstStudied?: string;
  lastStudied?: string;
  moduleStats?: Map<string, QuizModuleStat>;
};

export const defaultQuizStat: QuizStatType = {
  marksTotal: undefined,
  totalStudyTime: undefined,
  sessionsCompleted: undefined,
  firstStudied: undefined,
  lastStudied: undefined,
  moduleStats: Map<string, QuizModuleStat>()
};

export default class QuizStat extends Record(defaultQuizStat) {}
